<template>
  <div class="px-2 md:mx-48 border-4 border-gray-700 md:my-10">
    <!-- <pre>
      {{ payment_schedule }}
    </pre> -->
    <!-- <pre>
      {{ payment_schedule_header }}
    </pre> -->
    <!-- <pre
      >{{ payment_schedule_header[0] }}
    </pre> -->
    <div class="md:flex">
      <v-text-field
        label="Customer ID"
        v-model="customercode"
        class="md:mr-10"
        readonly
      ></v-text-field>
      <v-text-field
        name="name"
        label="Contract Number"
        v-model="contract_number"
        readonly
      ></v-text-field>
    </div>
    <div class="font-bold text-lg">
      PAYMENT TERMS AND PAYMENT SCHEDULE
    </div>
    <div class="text-center font-bold text-xl bg-blue-800 py-2 text-white">
      Account Details
    </div>
    <div class="py-2">
      <div>
        <div class="flex">
          <div class="w-64">
            Buyer’s Name
          </div>
          <div class="border border-gray-400 w-full">
            <input v-model="buyer_name" type="text" />
          </div>
        </div>
        <div class="flex">
          <div class="w-64">
            Project
          </div>
          <div class="border border-gray-400 w-full">
            <input v-model="project" type="text" />
          </div>
        </div>
        <div class="flex">
          <div class="w-64">
            Property Details
          </div>
          <div class="border border-gray-400 w-full">
            <input v-model="property" type="text" />
          </div>
        </div>
        <div class="flex">
          <div class="w-64">
            House Model
          </div>
          <div class="border border-gray-400 w-full">
            <input v-model="house_model" type="text" />
          </div>
        </div>
        <div class="flex">
          <div class="w-64">Contract Number</div>
          <div class="border border-gray-400 w-full">
            <input v-model="contract_number" type="text" />
          </div>
        </div>
        <div class="flex my-4">
          <div class="w-1/2 mr-10">
            <div class="bg-gray-300 py-2 w-full text-center">
              LOT DETAILS
            </div>
            <div class="pt-2 flex">
              <div class="w-1/4">
                Lot Size
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="lot_size" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/4">
                Lot Price / sqm
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="lot_price_sqm" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/4">
                Lot Price
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="lot_price" type="text" />
              </div>
            </div>
          </div>
          <div class="w-1/2 mr-10">
            <div class="bg-gray-300 py-2 w-full text-center">
              HOUSE DETAILS
            </div>
            <div class="flex pt-2">
              <div class="w-1/3">
                House Size
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="house_size" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/3">
                house Price / sqm
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="house_price_sqm" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/3">
                H AND L Total TCP
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="total_tcp" type="text" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- PAYMENT TERMS  -->
    <div class="text-center font-bold text-xl bg-blue-800 py-2 text-white">
      Payment Terms
    </div>
    <div class="py-2">
      <div>
        <div class="flex">
          <div class="w-64">
            Financing
          </div>
          <div class="border border-gray-400 w-full">
            <input v-model="Financing" type="text" />
          </div>
        </div>
        <div class="flex">
          <div class="w-64">
            Total Contract Price
          </div>
          <div class="border border-gray-400 w-full">
            <input v-model="total_contract_price" type="text" />
          </div>
        </div>
        <div class="flex my-4">
          <div class="w-1/2 mr-10">
            <div class="bg-gray-300 py-2 w-full text-center">
              Down Payment
            </div>
            <div class="pt-2 flex">
              <div class="w-1/3">
                % of TCP
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="percent_of_tcp" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/3">
                Total Downpayment
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="total_downpayment" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/3">
                DP Period
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="dp_period" type="text" />
              </div>
            </div>
          </div>
          <div class="w-1/2 mr-10">
            <div class="bg-gray-300 py-2 w-full text-center">
              Remaining Balance
            </div>
            <div class="flex pt-2">
              <div class="w-1/3">
                % of TCP
              </div>
              <div class="w-full border border-gray-400">
                <input
                  class="w-full"
                  v-model="rem_percent_of_tcp"
                  type="text"
                />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/3">
                Total Rem. Bal.
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="total_rem_balance" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/3">
                Amortization Period
              </div>
              <div class="w-full border border-gray-400">
                <input
                  class="w-full"
                  v-model="amortization_period"
                  type="text"
                />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/3">
                Interest Rate
              </div>
              <div class="w-full border border-gray-400">
                <input class="w-full" v-model="interest_rate" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="w-1/3">
                Monthly Amortization
              </div>
              <div class="w-full border border-gray-400">
                <input
                  class="w-full"
                  v-model="monthly_amortization"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="flex"></div>
          <div>
            <div>
              <table class="w-full" id="table">
                <thead class="bg-gray-300">
                  <tr>
                    <td class="p-2">Other Payments</td>
                    <td class="p-2">
                      Amount
                    </td>
                    <td class="p-2">
                      Due Date
                    </td>
                  </tr>
                </thead>
                <tr>
                  <td>
                    Registration Fee
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    Move-in Fee
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    Real Property Tax
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    Fire Insurance
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div>
          <div
            class="text-center font-bold text-xl bg-blue-800 py-2 text-white md:mt-10"
          >
            PAYMENT SCHEDULE
          </div>
          <v-data-table
            :headers="payment_schedule_headers"
            :items="payment_schedule"
            :search="search_psched"
          >
          </v-data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SecureStorage from "../../utils/secureStorage";

export default {
  data() {
    return {
      payment_schedule_headers: [
        {
          text: "Due Date",
          value: "0",
        },

        {
          text: "Amount",
          value: "1",
        },
        {
          text: "Balance",
          value: "2",
        },
        {
          text: "Details",
          value: "3",
        },
      ],
      search_psched: "",
      payment_schedule: [],
      payment_schedule_header: [],
      customercode: "",
      contract_number: "",
      buyer_name: "",
      project: "",
      property: "",
      house_model: "",
      lot_size: "",
      lot_price_sqm: "",
      lot_price: "",
      house_size: "",
      house_price_sqm: "",
      total_tcp: "",
      Financing: "",
      total_contract_price: "",
      percent_of_tcp: "",
      total_downpayment: "",
      dp_period: "",
      rem_percent_of_tcp: "",
      total_rem_balance: "",
      amortization_period: "",
      interest_rate: "",
      monthly_amortization: "",
    };
  },
  watch: {
    customercode: {
      handler(e) {
        this.populate_payment_schedule_detail(e);
        this.populate_payment_schedule_header(e);
      },
      immediate: true,
    },
  },
  mounted() {
    this.customercode = SecureStorage.getItem("auth").customercode;
    this.contract_number = SecureStorage.getItem("auth").contract_number;
  },
  methods: {
    populate_payment_schedule_detail(e) {
      let data = {
        customercode: e,
        contract_number: this.contract_number,
      };

      axios.post("/cs_data/payment_schedule_detail", data).then((res) => {
        this.payment_schedule = res.data.pterm_detail;
      });
    },
    populate_payment_schedule_header(e) {
      let data = {
        customercode: e,
        contract_number: this.contract_number,
      };

      axios.post("/cs_data/payment_schedule_header", data).then((res) => {
        this.payment_schedule_header = res.data.pterm_detail_header;
        this.buyer_name = this.payment_schedule_header[0][1];
        this.project = this.payment_schedule_header[0][2];
        this.property =
          this.payment_schedule_header[0][6] +
          " " +
          this.payment_schedule_header[0][5] +
          " " +
          this.payment_schedule_header[0][4];
        this.house_model = this.payment_schedule_header[0][7];
        this.lot_size = this.payment_schedule_header[0][8];
        this.Financing = this.payment_schedule_header[0][9];
        this.dp_period = this.payment_schedule_header[0][10];
        this.monthly_amortization = this.payment_schedule_header[0][11];
        this.registration_fee = this.payment_schedule_header[0][12];
      });
    },
  },
};
</script>

<style>
#table td {
  border: rgba(0, 0, 0, 0.3) solid 1px;
  padding: 4px;
}
</style>
